module.exports = __webpack_public_path__ + "img/engel_ck100.5397c491.png";